import { Helmet } from 'react-helmet';
import { EditSellerRestaurant } from 'src/components/EditSellerRestaurant';

const EditSellerRestaurantPage = () => (
  <>
    <Helmet>
      <title> Edit Restaurant</title>
    </Helmet>

    <EditSellerRestaurant />
  </>
);

export default EditSellerRestaurantPage;
